module.exports = __webpack_public_path__ + "img/01.af22693d.png";